@if (authService.hasPermission(Permission.ProductsViewLink)) {
  <a
    mat-menu-item
    [disabled]="isDisabled"
    target="_blank"
    [href]="product.productLink"
    >
    <mat-icon>open_in_new</mat-icon>
    <span>Product Link</span>
  </a>
}
